import axios from 'axios'
import { cloudinaryUrl } from '../../../../urls'

const cloudinaryInstance = axios.create({
	baseURL: cloudinaryUrl,
})

export default cloudinaryInstance
